import { render, staticRenderFns } from "./UpgradeDialog.vue?vue&type=template&id=0191a80d&scoped=true&"
import script from "./UpgradeDialog.vue?vue&type=script&lang=ts&"
export * from "./UpgradeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeDialog.vue?vue&type=style&index=0&id=0191a80d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191a80d",
  null
  
)

export default component.exports